import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Container, Row, Form, Label, Input, FormFeedback, Alert } from 'reactstrap';

import AuthSlider from '../authCarousel';

//formik
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { userForgetPassword, userForgetPasswordUpdate } from 'live-slices/auth/forgetpwd/thunk';
import { toast } from 'react-toastify';
import ErrorModal from 'Components/Common/ErrorModal';

const CoverPasswCreate = (props: any) => {
    document.title = "Reset Password | BuyPass";

    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const validation: any = useFormik({
        enableReinitialize: true,

        initialValues: {
            username: '',
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Please Enter Your Email").test(
                "is-valid-email",
                "Invalid email format (must include '@' and '.com , pk , ai ,etc.')",
                value => value?.includes("@") && value?.includes(".")
            ),
        }),
        onSubmit: async (values) => {
            const payload = {
                ...values,
                username: values.username.toLowerCase(),
            };

            const result = await dispatch(userForgetPasswordUpdate(payload));

            if (result?.success) {
                setShowModal({ isVisible: true, color: true });
                setErrorMessage(result.message)
                setTimeout(() => {
                    setShowModal({ isVisible: false, color: true });
                }, 3000);
                // navigate("/login");
                return;
            } else {
                setShowModal({ isVisible: true, color: false });
                console.log(result.message)
                if (result.message === "User Not Found") {
                    setErrorMessage("This email is not registered with BuyPass");
                    } else {
                    setErrorMessage(result.message);
                    }

                setTimeout(() => {
                    setShowModal({ isVisible: false, color: false });
                }, 2000);
                return;
            }
        }

    });


    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showModal, setShowModal] = useState({
        isVisible: false,
        color: false,
    });



    return (
        <React.Fragment>
            <ErrorModal
                show={showModal.isVisible}
                message={errorMessage}
                color={showModal.color}
                onCloseClick={() => setShowModal({ isVisible: false, color: false })}
            />

            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100 auth-form">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="Specific-Class-for-border overflow-hidden">
                                    <Row className="justify-content-center g-0">
                                        <AuthSlider />

                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <h1 className="">Forgot Password?</h1>
                                                <p className="">Reset password with BuyPass</p>

                                                <Alert className="border-0 alert-warning text-center  my-4" role="alert">
                                                    Enter your email and instructions will be sent to you!
                                                </Alert>
                                                <div className="">
                                                    <Form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                    >
                                                        <div className=" formContainer">
                                                            <label className="form-label" htmlFor="email-input">Email</label>
                                                            <Input
                                                                name="username"
                                                                className="form-control leftPad"
                                                                placeholder="Enter Your Email"
                                                                data-testing-Id="emialInput_login"
                                                                type="text"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.username || ""}
                                                                invalid={
                                                                    validation.touched.username && validation.errors.username ? true : false
                                                                }
                                                            />
                                                            {validation.touched.username && validation.errors.username ? (
                                                                <FormFeedback type="invalid">
                                                                    <div>{validation.errors.username}</div>
                                                                </FormFeedback>
                                                            ) : null}
                                                            <i className="ri-mail-line text-secondary lefticonInfoDv"></i>

                                                        </div>


                                                        <div className="text-center mt-4">
                                                            <Button color="secondary" className=" w-100" type="submit" data-testing-id="sendLinkButton_login">
                                                                Send Reset Link
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </div>


                                                <div className=' text-center mt-5'>
                                                    <p>Wait, I remember my password...
                                                        <Link to="/auth-signin-cover" className="text-muted mt-2 " data-testing-Id="creatAccount_login" data-testing-id="clickHereLink_login"><span className='text-secondary ms-1'>Click here</span></Link>
                                                    </p>
                                                </div>


                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()}
                                        BuyPass. Crafted with <i className="mdi mdi-heart text-danger"></i> by Themesbrand</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default CoverPasswCreate;